module.exports = __webpack_public_path__ + "img/girl-qstand.a75d8c4c.jpg";